module.exports = __webpack_public_path__ + "static/media/Frame.865cd16d.png";